var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResultIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.18096 2.34501C9.21666 2.15385 9.3181 1.98119 9.4677 1.85694C9.61731 1.73269 9.80565 1.66468 10.0001 1.66468C10.1946 1.66468 10.3829 1.73269 10.5325 1.85694C10.6821 1.98119 10.7836 2.15385 10.8193 2.34501L11.6951 6.97668C11.7573 7.30597 11.9174 7.60886 12.1543 7.84582C12.3913 8.08278 12.6942 8.2428 13.0235 8.30501L17.6551 9.18084C17.8463 9.21655 18.0189 9.31799 18.1432 9.46759C18.2674 9.61719 18.3355 9.80554 18.3355 10C18.3355 10.1945 18.2674 10.3828 18.1432 10.5324C18.0189 10.682 17.8463 10.7835 17.6551 10.8192L13.0235 11.695C12.6942 11.7572 12.3913 11.9172 12.1543 12.1542C11.9174 12.3912 11.7573 12.6941 11.6951 13.0233L10.8193 17.655C10.7836 17.8462 10.6821 18.0188 10.5325 18.1431C10.3829 18.2673 10.1946 18.3353 10.0001 18.3353C9.80565 18.3353 9.61731 18.2673 9.4677 18.1431C9.3181 18.0188 9.21666 17.8462 9.18096 17.655L8.30512 13.0233C8.24292 12.6941 8.08289 12.3912 7.84593 12.1542C7.60897 11.9172 7.30608 11.7572 6.97679 11.695L2.34512 10.8192C2.15396 10.7835 1.9813 10.682 1.85706 10.5324C1.73281 10.3828 1.66479 10.1945 1.66479 10C1.66479 9.80554 1.73281 9.61719 1.85706 9.46759C1.9813 9.31799 2.15396 9.21655 2.34512 9.18084L6.97679 8.30501C7.30608 8.2428 7.60897 8.08278 7.84593 7.84582C8.08289 7.60886 8.24292 7.30597 8.30512 6.97668L9.18096 2.34501Z",
    stroke: "#0A0A0A",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 1.66666V5",
    stroke: "#0A0A0A",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 3.33334H15",
    stroke: "#0A0A0A",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33341 18.3333C4.25389 18.3333 5.00008 17.5871 5.00008 16.6667C5.00008 15.7462 4.25389 15 3.33341 15C2.41294 15 1.66675 15.7462 1.66675 16.6667C1.66675 17.5871 2.41294 18.3333 3.33341 18.3333Z",
    stroke: "#0A0A0A",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultIcon);
export default __webpack_public_path__ + "static/media/resultIcon.746a1982eb6037050770da28f021e223.svg";
export { ForwardRef as ReactComponent };